import axios from 'axios';

const API_BASE_URL = 'https://medi-panel.cloud/api/admin';

class UserService {

  // Tüm kullanıcıları getir
  async getAllUsers() {
    try {
      const token = sessionStorage.getItem('token');
      console.log('🔐 Getting users with token:', token ? '✅' : '❌');

      const response = await axios.get(`${API_BASE_URL}/users`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('✅ Users fetched successfully:', response.data);
      return response.data;

    } catch (error) {
      console.error('❌ Error fetching users:', error);
      throw error;
    }
  }

  // Kullanıcı durumunu değiştir (Aktif/Pasif)
  async toggleUserStatus(userId) {
    try {
      const token = sessionStorage.getItem('token');

      const response = await axios.patch(`${API_BASE_URL}/users/${userId}/status`, {}, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('✅ User status toggled:', response.data);
      return response.data;

    } catch (error) {
      console.error('❌ Error toggling user status:', error);
      throw error;
    }
  }

  // Yeni kullanıcı oluştur
  async createUser(userData) {
    try {
      const token = sessionStorage.getItem('token');

      const response = await axios.post(`${API_BASE_URL}/users`, userData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('✅ User created:', response.data);
      return response.data;

    } catch (error) {
      console.error('❌ Error creating user:', error);
      throw error;
    }
  }

  // Kullanıcı güncelle
  async updateUser(userId, userData) {
    try {
      const token = sessionStorage.getItem('token');

      const response = await axios.put(`${API_BASE_URL}/users/${userId}`, userData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('✅ User updated:', response.data);
      return response.data;

    } catch (error) {
      console.error('❌ Error updating user:', error);
      throw error;
    }
  }
}

export default new UserService();